import { defineComponent as t, useSlots as c, unref as s, openBlock as a, createElementBlock as i, createElementVNode as l, normalizeClass as p, renderSlot as m, createCommentVNode as u } from "vue";
const d = {
  key: 0,
  class: "hl-icon-container"
}, f = t({
  __name: "IconContainer",
  props: {
    type: {
      type: String,
      default: "primary"
    }
  },
  setup(e) {
    const n = {
      success: "icon-success",
      error: "icon-error",
      warning: "icon-warning",
      primary: "icon-primary"
    }, o = c();
    return (r, y) => s(o).default() ? (a(), i("div", d, [
      l("div", {
        class: p(["icon", n[e.type]])
      }, [
        m(r.$slots, "default")
      ], 2)
    ])) : u("", !0);
  }
}), C = f;
export {
  C as default
};
